<i18n lang="yml" src='../i18n/BookingReview.yml'></i18n>
<template>
  <div v-if="active">
    <div class='row border-bottom'>
      <div class="col-sm-12 mb-4">
        <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">

          <ul class="booking-details-list">
            <h5 class="heading-page mt-0">
              {{$t('details')}} 
            </h5>

            <li class="row">
              <span class="status-bold col-xs-12 col-md-5">
                {{$t('exam')}}
              </span>
              <span class="col-xs-12 col-md-6">
                {{details.training_program_full_name}} - {{details.exam_type_name ? details.exam_type_name[locale] : ''}} - {{details.language}}
              </span>
            </li>
      
            <li class="row" v-if="details.accommodations && details.accommodations.accommodation_types.length > 0">
                <span class="status-bold col-xs-12 col-md-5">
                  {{$t('accommodation_requests')}}
                </span>
                <ul>
                  <li v-for="accommodation in details.accommodations.accommodation_types" :key="accommodation.id">
                  {{$t(`accommodations.${accommodation}`)}}
                  </li>
                </ul>
              <hr/>
            </li>

            <div class="alert alert-info help-block">
              <font-awesome-icon :icon="['fa', 'info-circle']" />
              <span class="pl-2" v-html="$t('time_to_book_warning')"></span>
            </div>

            <li class="row">
              <span class="status-bold col-xs-12 col-md-5">
                {{$t('exam_challenger')}}
              </span>
              <span class="col-xs-12 col-md-6">
                {{details.user_name}}
              </span>
            </li>
            <template :key="`${sitting.id}_location`" v-for="sitting in details.sittings">
              <div class="booking-details-list">
                <li class="row">
                  <span class="status-bold col-xs-12 col-md-5">
                    {{$t('exam_location')}}
                  </span>
                  <span class="col-xs-12 col-md-6">
                    {{sitting.sub_location.name[locale]}}
                  </span>
                </li>
                <li class="row" :key="`${sitting.id}_address`">
                  <span class="status-bold col-xs-12 col-md-5">
                    {{$t('exam_location_address')}}
                  </span>
                  <span class="col-xs-12 col-md-6">
                    {{sitting.sub_location.street_address}} {{sitting.sub_location.city}}, {{sitting.sub_location.province}} {{sitting.sub_location.postal_code}}
                  </span>
                </li>
                <li class="row" :key="`${sitting.id}_date`">
                  <span class="status-bold col-xs-12 col-md-5">
                    {{$t('exam_date')}}
                  </span>
                  <span class="col-xs-12 col-md-6">
                    {{formatDate(sitting.date)}}
                  </span>
                </li>
                <li class="row" :key="`${sitting.id}_time`">
                  <span class="status-bold col-xs-12 col-md-5">
                    {{$t('exam_time')}}
                  </span>
                  <span class="col-xs-12 col-md-6">
                    {{formatTime(sitting.start_time)}}
                  </span>
                </li>
              </div>
            </template>
          </ul>

          <a class='btn btn-sm btn-success' @click.prevent="nextStep()">
            {{ $t('book_now') }}
          </a>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Stepper from './Stepper.vue'
import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'
export default {
  props: ['locale', 'base_path', 'details', 'active', 'time_format_en', 'time_format_fr'],
  components: {
    'stepper': Stepper
  },
  data() {
    return {}
  },

  methods: {
    formatDate(dateString) {
      return formatDate(dateString)
    },
    formatTime: function (date) {
      let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
      return formatTime(date, format)
    },
    nextStep() {
      this.$emit('nextStep');
    }
  }
}
</script>
